import { useQuery } from '@tanstack/react-query';
import { api } from '../api/cliente';
import type { ItemIndice } from './busca';

/** Índice do Ctrl+K: uma vez por sessão; SignalR dicionarioAlterado/recursosAlterados invalida (07 §2.5). */
export function useIndice() {
  return useQuery({ queryKey: ['indice'], queryFn: () => api.get<ItemIndice[]>('/menu/indice'), staleTime: 10 * 60_000 });
}

export interface ItemMenu {
  tipo: 'grupo' | 'submenu' | 'rotina' | 'separador';
  codigo: string | null;
  nome: string;
  icone?: string | null;
  atalho?: string | null;
  itens: ItemMenu[];
}

export interface MenuModulo {
  modulo: { codigo: string; nome: string; icone?: string | null; ordem: number };
  grupos: ItemMenu[];
}

export function useMenu(modulo: string | undefined) {
  return useQuery({
    queryKey: ['menu', modulo],
    queryFn: () => api.get<MenuModulo>(`/menu?modulo=${encodeURIComponent(modulo!)}`),
    enabled: !!modulo,
    staleTime: 10 * 60_000,
  });
}
